<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                    <van-col span="12">
                        <div class="banner-title">历史周报</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="weekly" @click="toWeekly">
                <div class="weekly-range">{{weeklyRange}}</div>
            </div>
            <div class="month" @click="toMonth">
                <div class="month-range">{{monthRange}}</div>
            </div>
            <div class="year" @click="toYear">
                <div class="month-range">{{yearRange}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable} from '@/utils/comment'
    import {getMonthStartDay, GetMonth} from '@/utils/dateUtils'
    import {WebJSBridge} from "../../utils/JSBridge1";
    export default {
        name: 'list',
        data() {
            return {
                weeklyRange: '',
                monthRange: '',
                yearRange: '',
                userId: getQueryVariable('userId')
            }
        },
        mounted() {
            this.getMonth();
            this.getWeeklyRange();
            this.getYearRange();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            getMonth() {
                let date = new Date(getMonthStartDay(-1));
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                this.monthRange = year + '年' + month + '月';
            },
            getWeekLastDay() {
                let date = new Date();
                let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
                let weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000)
                weekLastDay.setDate(weekLastDay.getDate() - 7);
                let lastMonth = Number(weekLastDay.getMonth()) + 1
                let weekLastDays = weekLastDay.getDate();
                return lastMonth + '月' + weekLastDays + '日';
            },
            getWeekFirstDay() {
                let date = new Date();
                let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000);
                weekFirstDay.setDate(weekFirstDay.getDate() - 7);
                let firstMonth = Number(weekFirstDay.getMonth()) + 1
                let weekFirstDays = weekFirstDay.getDate();
                return firstMonth + '月' + weekFirstDays + '日';
            },
            getWeeklyRange() {
                this.weeklyRange = this.getWeekFirstDay() + ' - ' + this.getWeekLastDay();
            },
            getYearRange() {
                let date = new Date();
                let year = date.getFullYear();
                let lastYear = year - 1;
                this.yearRange = lastYear + '年';
            },
            toWeekly() {
                debugger
                console.log(this.userId)
                this.$router.push({
                    name: 'weekly',
                    query: {
                        userId: this.userId
                    }
                })
            },
            toMonth() {
                this.$router.push({
                    name: 'month',
                    query: {
                        userId: this.userId
                    }
                })
            },
            toYear() {
                this.$router.push({
                    name: 'openYear',
                    query: {
                        userId: this.userId
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .content {
        width: 100%;
        height: 100%;
        position: relative;
        margin-top: 88px;
    }

    .weekly {
        position: absolute;
        width: 345px;
        height: 105px;
        left: 15px;
        top: 12px;
        background: url("~@/assets/report/list/weekly.png");
        background-size: 100%;
    }

    .month {
        position: absolute;
        width: 345px;
        height: 105px;
        left: 15px;
        top: 131px;
        background: url("~@/assets/report/list/month.png");
        background-size: 100%;
    }

    .year {
        position: absolute;
        width: 345px;
        height: 105px;
        left: 15px;
        top: 248px;
        background: url("~@/assets/report/list/year.png");
        background-size: 100%;
    }

    .weekly-range {
        position: absolute;
        left: 22px;
        top: 75px;
        font-size: 15px;
    }

    .month-range {
        position: absolute;
        left: 22px;
        top: 77px;
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/report/list.vue